const roles = {
  ROLE_CUSTOMER: "ROLE_CUSTOMER",
  ROLE_GUEST: "ROLE_GUEST",
};

export default roles;
